/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {supportChatStatus} from '../api'

export const useMutationSupportChatStatus = createReactQueryMutationHook('supportChatStatus', supportChatStatus)
